import { c as _c } from "react/compiler-runtime";
/**
 * @Author: JulienBigot7 julien@generation-internet.biz
 * @Date: 2024-10-22 12:01:34
 * @LastEditors: JulienBigot7 julien@generation-internet.biz
 * @LastEditTime: 2024-12-10 09:57:30
 * @FilePath: src/components/global/public-bottom-nav.tsx
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */

import Link from "next/link";
import React from "react";
import Button from "@/components/button";
function PublicBottomNav() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Link href="/creer-un-club" prefetch={true}><Button className="bg-white mx-2 p-4" variant="unfilled">Créer mon club</Button></Link>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="sticky md:hidden bg-primary bottom-0 left-0 w-full z-[49]"><div className="flex justify-center mx-2 py-4">{t0}<Link href="/clubs" prefetch={true}><Button className="bg-white mx-2 p-4" variant="unfilled">Rejoindre un club</Button></Link></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default PublicBottomNav;